import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuPortal,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@radix-ui/react-dropdown-menu";
import { useCurrentUser } from "../../api/auth";
import "../DropdownMenu.css";

// Initials from a display name ("Richard Siebeling" → "RS") or, failing that,
// the email's first two letters. Always returns something renderable.
function initialsFrom(name, email) {
  const src = (name || "").trim();
  if (src) {
    const parts = src.split(/\s+/);
    const chars = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : src.slice(0, 2);
    return chars.toUpperCase();
  }
  return (email || "?").slice(0, 2).toUpperCase();
}

export default function ProfileMenu() {
  const { keycloak } = useKeycloak();
  const { data: user } = useCurrentUser();
  const name = user?.name || "";
  const email = user?.email || "";
  const initials = initialsFrom(name, email);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Account menu"
          className="inline-flex items-center justify-center box-border rounded-full bg-primary-soft-strong border border-solid border-primary-soft text-primary text-[12px] font-bold cursor-pointer transition-colors hover:bg-primary-soft"
          style={{ width: 36, height: 36 }}
        >
          {initials}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent className="DropdownMenuContent w-[240px]" side="bottom" align="end" sideOffset={8}>
          <div className="px-3 py-2">
            <div className="text-[13px] font-semibold text-text truncate">{name || "Signed in"}</div>
            {email && <div className="text-[12px] text-text-3 truncate">{email}</div>}
          </div>
          <DropdownMenuSeparator className="DropdownMenuSeparator" />
          <DropdownMenuItem
            className="DropdownMenuItem cursor-pointer"
            onSelect={() => keycloak.logout()}
          >
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
